import _ from 'lodash-es';
import angular from 'angular';

export default class ModalKjsonController {
	/* @ngInject */
	/**
	 * @param {any} $copyToClipboard
	 * @param {import('angular').IFilterService} $filter
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {string} label
	 * @param {boolean} disabled
	 * @param {any} kjson
	 */
	constructor(
		$copyToClipboard,
		$filter,
		$translate,
		$uibModalInstance,
		label,
		disabled,
		kjson,
	) {
		this.$copyToClipboard = $copyToClipboard;
		this.$filter = $filter;
		this.$translate = $translate;
		this.$uibModalInstance = $uibModalInstance;
		this.label = label;
		this.disabled = disabled;

		/** @type {?(import('angular').IFormController)} */
		this.form = null;

		this.kjson = kjson;

		/** @type {{data?: any, options?: import('jsoneditor').JSONEditorOptions }} */
		this.obj = {};
	}

	copyAll() {
		this.$copyToClipboard(
			angular.toJson(this.kjson, true),
			true,
			(/** @type {string} */ v) => this.$filter('sprintf')(
				this.$translate.instant('common.x-copied-to-clipboard'),
				`<samp>${v.slice(0, 30)}...</samp>`,
			),
		);
	}

	$onInit() {
		/** @type {import('jsoneditor').JSONEditorMode[]} */
		const modes = this.disabled ? ['view'] : ['tree', 'view', 'form', 'code', 'text'];

		/** @type {import('jsoneditor').JSONEditorMode} */
		const mode = this.disabled ? 'view' : 'tree';

		this.obj = {
			data:    this.kjson,
			options: {
				mode,
				modes,
			},
		};
	}

	cancel() {
		return this.$uibModalInstance.dismiss('cancel');
	}

	isEmpty() {
		return this.obj && (
			_.isEqual(this.obj.data, {}) || this.obj.data === '' || this.obj.data === null || this.obj.data === undefined
		);
	}

	save() {
		if (this.isEmpty()) {
			this.obj.data = null;
		}
		return this.$uibModalInstance.close({ kjson: this.obj?.data });
	}
}
